module.exports = __webpack_public_path__ + "static/media/20210410_181548_424_IMG_0274.024b266d.jpg";